import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import { ISingParameters } from '../../../types/kpis';
import { palette } from '../palette';

interface IMainImpactChart {
  data: ISingParameters[];
  width?: number;
}

const MainImpactChart: React.FC<IMainImpactChart> = ({ data, width = 600 }) => {
  const chartData = useMemo(() => {
    const values: { name: string; data: number[] }[] = [];
    const categories: string[] = [];

    data.forEach((dt, index) => {
      const newData = new Array(data.length).fill(0);
      newData.splice(index, 1, dt.value * 100);

      values.push({
        name: dt.name.toUpperCase(),
        data: newData,
      });
      categories.push(dt.name);
    });

    return { values, categories };
  }, [data]);

  return (
    <Chart
      type="bar"
      width={width}
      height={320}
      series={chartData.values}
      options={{
        chart: {
          fontFamily: 'Poppins',
          type: 'bar',
          stacked: true,
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        colors: palette,
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: chartData.categories,
          position: 'top',
          axisBorder: {
            show: false,
          },
          labels: {
            show: true,
            formatter: value => `${value}%`,
          },
          tickAmount: 8,
        },
        yaxis: {
          min: -100,
          max: 100,
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          enabled: false,
        },
        grid: {
          strokeDashArray: 4,
          yaxis: {
            lines: {
              show: false,
            },
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        legend: {
          show: false,
        },
      }}
    />
  );
};

export default MainImpactChart;
